import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { type ProcessedVideoNotification } from '@/components/layout/header/NotificationsMenu';

interface VideoNotificationsResponse {
  success: boolean;
  data: ProcessedVideoNotification[];
}

export function useVideoNotifications() {
  const { data, isLoading } = useQuery<VideoNotificationsResponse>({
    queryKey: ['video-notifications'],
    queryFn: () => api.get<VideoNotificationsResponse>('/videos/notifications/completed'),
    staleTime: 2 * 60 * 1000,       // não revalida por 2 min
    refetchInterval: 5 * 60 * 1000, // polling a cada 5 min (igual ao revenue)
  });

  return {
    recentlyReadyVideos: data?.data ?? [],
    isLoading,
  };
}
